<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车主姓名：</span>
        </div>
        <el-input v-model="carOwnerName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">车主手机号：</span>
        </div>
        <el-input v-model="carOwnerPhone" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">车牌号：</span>
        </div>
        <el-input v-model="carNumber" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">所属住户：</span>
        </div>
        <el-input v-model="enterpriseName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">备注：</span>
        </div>
        <el-input v-model="memo" size="small" style="width: 280px" />
      </div>

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/ParkingService'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nError, nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  import InputDatePicker from '../../../components/Input/InputDatePicker'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      InputDatePicker,
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'black-list-vehicles-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧停车',
            name: 'parking-device-management'
          }, {
            value: '黑名单'
          }],
        },
        mainTitle: '修改黑名单',
        rentList: [],
        subheading: '',
        personName: '',
        identityNumber: '',
        workType: '',
        certificate: '',

        code: '',
        carOwnerName: '',
        carOwnerPhone: '',
        carNumber: '',
        isWhite: '0',
        enterpriseName: '',
        memo: ''
      }
    },
    created () {
      this.code = this.$route.params.id
      this.getCarCarWhiteBlackByCode()
      this.bindAccountName = bus.global.accountName
      this.bindAccountCode = bus.global.accountCode
    },
    methods: {
      // 获取详情
      getCarCarWhiteBlackByCode () {
        this.$axios.get(`${api.getCarCarWhiteBlackByCode}/${this.code}`, {})
          .then(res => {
            let data = res.data.data
            this.carOwnerName = data.carOwnerName
            this.carOwnerPhone = data.carOwnerPhone
            this.carNumber = data.carNumber
            this.enterpriseName = data.enterpriseName
            this.memo = data.memo
          })
          .catch(errorHandler('获取详情失败'))
      },
      confirm () {
        if (!this.carOwnerName) {
          nError('请输入车主姓名')
          return false
        }
        if (!this.carNumber) {
          nError('请输入车牌号')
          return false
        }
        let obj = {
          code: this.code,
          carOwnerName: this.carOwnerName,
          carOwnerPhone: this.carOwnerPhone,
          carNumber: this.carNumber,
          isWhite: this.isWhite,
          enterpriseName: this.enterpriseName,
          memo: this.memo,
        }
        this.$axios.post(api.updateCarWhiteBlack, obj)
          .then(res => {
            if (res.data.retCode == 1) {
              nSuccess('修改成功')
              this.strategyCenter()
            }
          })
          .catch(errorHandler('修改失败'))
      },
      strategyCenter () {
        this.$router.push({
          name: 'black-list-vehicles-manage'
        })
      }
    },
    watch: {}
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/BlackListVehicles/BlackListVehiclesModify.vue